<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Dedication</h1>
</div>
</div>
<div>
<p class="head12" style="margin-top: 10em; text-align: center;">
<em>To Katy</em></p>
</div>
<p>
</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?ed112c52